import { buildSandboxedSrcDoc } from '@littlebird/canvas';

import {
  OFFICE_FRAME_NONCE_GLOBAL,
  type OfficeFrameKind,
} from './office-frame-protocol';

const OFFICE_FRAME_STYLES = `
html, body { margin: 0; height: 100%; }
body { background: #ffffff; overflow: auto; }
#office-content { min-height: 100%; width: fit-content; min-width: 100%; }
`;

const escapeInlineScript = (script: string): string =>
  script.replaceAll(/<\/script/gi, '<\\/script');

export const buildOfficeFrameSrcDoc = (
  runtimeSource: string,
  nonce: string
): string =>
  buildSandboxedSrcDoc(`<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8">
<style>${OFFICE_FRAME_STYLES}</style>
</head>
<body>
<div id="office-styles"></div>
<div id="office-content"></div>
<script>globalThis.${OFFICE_FRAME_NONCE_GLOBAL} = ${JSON.stringify(nonce)};</script>
<script>${escapeInlineScript(runtimeSource)}</script>
</body>
</html>`);

export const loadOfficeFrameSrcDoc = async (
  kind: OfficeFrameKind,
  nonce: string
): Promise<string> => {
  const { default: runtimeSource } =
    kind === 'docx'
      ? await import('virtual:office-frame-runtime/docx')
      : await import('virtual:office-frame-runtime/pptx');
  return buildOfficeFrameSrcDoc(runtimeSource, nonce);
};
